import { useContext } from "react";
import { AuthorizationContext } from "../AuthContext";
import { MeResponse } from "../../Api/ApiServer";

export interface UseAuthorization {
    isAuthenticated: boolean;
    isInitialized: boolean;
    login: (token: string, refreshToken: string, isAdmin: boolean, isSuperAdmin: boolean) => void;
    logout: () => void;
    token: string | null | undefined;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    userData: MeResponse | null;
}

export const useAuthorization = (): UseAuthorization => {
    const { isAuthenticated, isInitialized, login, logout, token, isAdmin, isSuperAdmin, userData } = useContext(AuthorizationContext);
    return { isAuthenticated, isInitialized, login, logout, token, isAdmin, isSuperAdmin, userData };
};